import React from 'react';
interface PaymentMethodsProps {
  label?: string;
  className?: string;
}
const cardClass = 'flex items-center justify-center h-9 md:h-10 px-3 md:px-4 rounded-lg bg-white shadow-sm border border-black/5';
export function PaymentMethods({
  label = 'PAGAMENTI ACCETTATI',
  className = ''
}: PaymentMethodsProps) {
  return <div className={`text-center ${className}`} data-id="element-144">
      {label && <p className="text-[10px] md:text-xs font-semibold tracking-[0.2em] text-gray-400 uppercase mb-3" data-id="element-145">
          {label}
        </p>}
      <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3" data-id="element-146">
        {/* Visa */}
        <div className={cardClass} aria-label="Visa" data-id="element-147">
          <span className="font-serif italic font-bold text-base md:text-lg text-[#1a1f71] tracking-tight" data-id="element-148">
            VISA
          </span>
        </div>

        {/* Mastercard */}
        <div className={cardClass} aria-label="Mastercard" data-id="element-149">
          <span className="relative inline-flex items-center" data-id="element-150">
            <span className="w-4 h-4 md:w-5 md:h-5 rounded-full bg-[#eb001b]" data-id="element-151" />
            <span className="w-4 h-4 md:w-5 md:h-5 rounded-full bg-[#f79e1b] -ml-2 mix-blend-multiply" data-id="element-152" />
          </span>
        </div>

        {/* Amex */}
        <div className={cardClass} aria-label="American Express" data-id="element-153">
          <span className="bg-[#2557d6] text-white font-bold text-[10px] md:text-xs px-1.5 py-0.5 rounded" data-id="element-154">
            AMEX
          </span>
        </div>

        {/* Apple Pay */}
        <div className={cardClass} aria-label="Apple Pay" data-id="element-155">
          <span className="flex items-center text-black font-medium text-sm md:text-base" data-id="element-156">
            <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 md:w-4 md:h-4 mr-0.5" fill="currentColor" aria-hidden="true" data-id="element-157">
              <path d="M17.05 12.04c-.02-2.05 1.68-3.04 1.76-3.09-.96-1.4-2.46-1.6-2.99-1.62-1.27-.13-2.48.75-3.13.75-.64 0-1.64-.73-2.7-.71-1.39.02-2.67.81-3.38 2.05-1.44 2.5-.37 6.2 1.03 8.23.69.99 1.51 2.1 2.58 2.06 1.03-.04 1.42-.67 2.67-.67 1.24 0 1.6.67 2.69.65 1.11-.02 1.81-1.01 2.49-2 .78-1.15 1.1-2.26 1.12-2.32-.02-.01-2.15-.83-2.17-3.27zM15.0 6.2c.56-.69.94-1.64.84-2.6-.81.03-1.8.54-2.38 1.22-.52.6-.98 1.57-.86 2.5.91.07 1.83-.46 2.4-1.12z" data-id="element-158" />
            </svg>
            Pay
          </span>
        </div>

        {/* Google Pay */}
        <div className={cardClass} aria-label="Google Pay" data-id="element-159">
          <span className="font-medium text-sm md:text-base" data-id="element-160">
            <span className="text-[#4285f4]" data-id="element-161">G</span>
            <span className="text-gray-500" data-id="element-162"> Pay</span>
          </span>
        </div>
      </div>
    </div>;
}